import javaScript from './skills-icons/js.png'
import html from './skills-icons/html5.png'
import css from './skills-icons/css.png'
import git from './skills-icons/git.png'
import heroku from './skills-icons/heroku.png'
import node from './skills-icons/node.png'
import npm from './skills-icons/npm.png'
import react from './skills-icons/react.png'
import sass from './skills-icons/sass.png'

export default function imageData() {
  return {
    javaScript,
    html,
    css,
    git,
    heroku,
    node,
    npm,
    react,
    sass
  }
}
